
      import PlusCircleFilled from './plus-circle-filled.vue'
      import type { App, Plugin } from 'vue'

      export const PlusCircleFilledPlugin: Plugin = {
        install(app: App) {
          app.component('PlusCircleFilled', PlusCircleFilled)
        },
      }
      export { PlusCircleFilled }
      